import { request } from '../boot/request';

const getProductDetails = (id, params) => {
  params = params || {};
  return request({
    url: `/products/${id}`,
    method: 'GET',
    params,
  });
};

const getVtecAddOns = productId => request({
  url: '/vtecAddons',
  method: 'GET',
  params: { productId },
});

export { getProductDetails, getVtecAddOns };
